import React, { useEffect, useMemo, useState } from 'react';
import { IPlayerLevel } from 'utils/types';
import { StyledPlayerLevel } from './style';
import { calculateTimeLeftLabel } from 'templates/PlayerLevel/utils';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import clockIcon from 'assets/cashman/clock.png';

const ENDS_IN_TEXT = 'ENDS IN: ';

export const CashmanCasinoTimerPlayerLevel: React.FC<IPlayerLevel> = ({
  endsIn = 0,
  assetUrl,
  onTimerDoneHandler,
}) => {
  const [timerText, setTimerText] = useState(
    calculateTimeLeftLabel({ text: ENDS_IN_TEXT, endsIn, onTimerDoneHandler }),
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setTimerText(
        calculateTimeLeftLabel({
          text: ENDS_IN_TEXT,
          endsIn,
          onTimerDoneHandler,
        }),
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [endsIn]);

  return (
    <StyledPlayerLevel className={'player-level sale'}>
      <img className={'image'} alt="icon" src={assetUrl ?? clockIcon} />
      {timerText && <div className="timer-text">{timerText}</div>}
    </StyledPlayerLevel>
  );
};
